
import * as React from 'react';
import {observer} from 'mobx-react-lite';
import styled from '@emotion/styled';
import {mainColors} from '../colors';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const PlusCircleIcon = observer(( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper width={20} height={20} className={className} fill={mainColors.default.light} viewBox='0 0 20 20'>
        <g fill='none' fillRule='evenodd'>
            <g fill='#000' fillRule='nonzero'>
                <g>
                    <g>
                        <path d='M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm4.375 10.833h-3.542v3.542c0 .46-.373.833-.833.833-.46 0-.833-.373-.833-.833v-3.542H5.625c-.46 0-.833-.373-.833-.833 0-.46.373-.833.833-.833h3.542V5.625c0-.46.373-.833.833-.833.46 0 .833.373.833.833v3.542h3.542c.46 0 .833.373.833.833 0 .46-.373.833-.833.833z' transform='translate(-912 -257) translate(900 247) translate(12 10)'/>
                    </g>
                </g>
            </g>
        </g>
    </SvgWrapper>

));
